(function ($) {
    jQuery(document).on('ready', function () {
        const browserElement = jQuery('.outdated-browser');

        jQuery(window).on('load', function () {
            if (isIE()) {
                browserElement.addClass('active');
                console.log('should open outdated browser popup');
            } else {
                console.log('should not open outdated browser popup');
            }
        });

        function isIE() {
            const ua = window.navigator.userAgent;
            const msie = ua.indexOf('MSIE ');
            const trident = ua.indexOf('Trident/');

            return (msie > 0 || trident > 0);
        }

        jQuery(document).on('click', '.outdated-browser.active *', function (e) {
            e.stopPropagation();
        });

        jQuery(document).on('click', '.outdated-browser, .outdated-browser__close', function (e) {
            jQuery('.outdated-browser').removeClass('active');
        });
    });
})(jQuery);
